import {apartmentAPI} from "../components/api/api";

const SET_APARTMENTS = 'SET_APARTMENTS';
const SET_APARTMENT_VIEW = 'SET_APARTMENT_VIEW';
const SET_IS_VISIBLE_LOADER = 'SET_IS_VISIBLE_LOADER';

let initialState = {
    apartments: [],
    apartment: null,
    isVisibleLoader: false
};

const apartmentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_APARTMENTS: {
            return {...state, apartments: action.apartments}
        }
        case SET_APARTMENT_VIEW: {
            return {...state, apartment: action.apartment}
        }
        case SET_IS_VISIBLE_LOADER: {
            return {...state, isVisibleLoader: action.isVisibleLoader}
        }
        default:
            return state;
    }
};

export const setApartments = (apartments) => ({
    type: SET_APARTMENTS, apartments
});
export const setApartment = (apartment) => ({
    type: SET_APARTMENT_VIEW, apartment
});
export const setIsVisibleLoader = (isVisibleLoader) => ({
    type: SET_IS_VISIBLE_LOADER, isVisibleLoader
});

export const getApartments = (apartments) => {
    return (dispatch) => {
        dispatch(setIsVisibleLoader(true));
        let arr = apartments;
        arr.splice(0, arr.length)
        dispatch(setApartments(arr))
        apartmentAPI.getLatestApartments()
            .then(data => {
                dispatch(setIsVisibleLoader(false));
                dispatch(setApartments(data))
            })
    }
};
export const getApartmentById = (apartment_uuid) => {
    return (dispatch) => {
        apartmentAPI.getApartmentByUUId(apartment_uuid)
            .then(data => {
                dispatch(setApartment(data))
            })
    }
}
export default apartmentsReducer;